<p-dialog [(visible)]="showUploadSlider" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  styleClass="upload-candidates-dialog" [style]="{width: '90vw', maxWidth: '600px'}" (onHide)="getCandidates()" class="neo-dialog">

  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">Upload Candidates</h2>
      <button 
        type="button" 
        class="dialog-close-btn"
        (click)="showUploadSlider = false"
        aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <div class="section">
          <h3 class="section-title">Download Sample Template</h3>
          <div class="template-download-card" (click)="downloadSampleTemplate()">
            <div class="template-info">
              <em class="pi pi-file-excel template-icon"></em>
              <span class="template-name">Move Candidate Template.xlsx</span>
            </div>
            <button class="download-btn" type="button">
              <em class="pi pi-download"></em>
            </button>
          </div>
        </div>

        <div class="section">
          <h3 class="section-title">Upload File <span class="required">*</span></h3>

          <div *ngIf="!templateUploaded" class="upload-area">
            <div class="dropzone" ngx-dropzone
              [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
              [multiple]="false" (change)="uploadTemplate($event)">
              <ngx-dropzone-label>
                <div class="dropzone-content">
                  <img src="assets/icons-svg/upload_file_icon.svg" alt="Settings" />
                  <p class="upload-text">
                    Drag & Drop your files here or
                    <span class="upload-link">Choose Files</span>
                  </p>
                  <p class="upload-hint">Recommended: .XLSX</p>
                </div>
              </ngx-dropzone-label>
            </div>
          </div>

          <div *ngFor="let f of template">
            <div class="uploaded-file" *ngIf="f.name">
              <div class="file-info">
                <em class="pi pi-file-excel file-icon"></em>
                <div class="file-details">
                  <p class="file-name">{{f.name}}</p>
                  <p class="file-size">{{templateSize}}</p>
                </div>
              </div>
              <button 
              type="button" 
              class="remove-file-btn"
              (click)="onRemoveExcel()">
              <em class="pi pi-times"></em>
            </button>
            </div>
          </div>

          <p class="upload-note">The template should contain only the candidate_uuid field. Maximum invite upto {{ bulkMoveStageLimit | number }} candidates .</p>
        </div>

        <div class="section">
          <label class="section-title">Remarks (Optional)</label>
          <textarea pInputTextarea placeholder="Enter remarks" [(ngModel)]="remarks" rows="4" class="remarks-textarea">
                  </textarea>
        </div>

        <div class="section" *ngIf="errorFileUrl">
          <div class="error-report">
            <h3 class="error-title">Error Report</h3>
            <button pButton type="button" label="Download Error Report" icon="pi pi-download" class="error-download-btn"
              (click)="downloadErrorReport()">
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button pButton type="button" label="Upload" class="send-invite-btn" [loading]="uploadBtnLoading" [disabled]="!interviewFileName || uploadBtnLoading"
        (click)="uploadCandidates(stage.stageId)">
      </button>
    </div>
  </div>
</p-dialog>


<p-dialog [(visible)]="showScheduleSlider" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  styleClass="schedule-candidates-dialog" [style]="{width: '600px', maxWidth: '90vw'}" (onHide)="bulkSchedule()" class="neo-dialog">

  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">Schedule Bulk Interview</h2>
      <button 
        type="button" 
        class="dialog-close-btn"
        (click)="showScheduleSlider = false"
        aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <div class="section">
          <label class="section-title">Select Candidates <span class="required">*</span></label>
          <div class="radio-group">
            <div class="radio-option">
              <p-radioButton [(ngModel)]="scheduleRadio" value="all" name="allButton" inputId="all"></p-radioButton>
              <label for="all" class="radio-label">All</label>
            </div>
            <div class="radio-option">
              <p-radioButton [(ngModel)]="scheduleRadio" value="unscheduled" name="unscheduledButton"
                inputId="unScheduled"></p-radioButton>
              <label for="unScheduled" class="radio-label">Unscheduled</label>
            </div>
          </div>
        </div>

        <div class="section">
          <label class="section-title">Download Template</label>
          <div class="template-download-card" (click)="templateDownload()">
            <div class="template-info">
              <i class="pi pi-file-excel template-icon"></i>
              <div>
                <div class="template-name">Bulk_Interview_Schedule_Template.xlsx</div>
              </div>
            </div>
            <button class="download-btn" type="button">
              <i class="pi pi-download"></i>
            </button>
          </div>
        </div>

        <div class="section">
          <label class="section-title">Upload Template <span class="required">*</span></label>

          <div class="upload-area" *ngIf="!templateUploaded">
            <div class="dropzone" ngx-dropzone
              [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
              [multiple]="false" (change)="uploadTemplate($event)">
              <ngx-dropzone-label>
                <div class="dropzone-content">
                  <i class="pi pi-upload upload-icon"></i>
                  <p class="upload-text">
                    Drag & Drop your files here or <span class="upload-link">Choose Files</span>
                  </p>
                  <p class="upload-hint">Recommended: .XLSX</p>
                </div>
              </ngx-dropzone-label>
            </div>
          </div>

          <div *ngFor="let f of template">
            <div class="uploaded-file" *ngIf="f.name">
              <div class="file-info">
                <i class="pi pi-file-excel file-icon"></i>
                <div class="file-details">
                  <p class="file-name">{{f.name}}</p>
                  <p class="file-size">{{templateSize}}</p>
                </div>
              </div>
              <button 
              type="button" 
              class="remove-file-btn"
              (click)="onRemoveExcel()">
              <em class="pi pi-times"></em>
            </button>
            </div>
          </div>
          <p class="upload-note">Maximum interview schedule upto {{ bulkInterviewScheduleLimit | number }} candidates</p>
          <!-- <p class="upload-note">Maximum invite upto 200 candidates .</p> -->
          <div class="format-instructions">
            <p class="format-title">Please make sure the format satisfies the following:</p>
            <ul class="format-list">
              <li>Interview Date: YYYY-MM-DD</li>
              <li>Start Time: HH:MM AM/PM (Must be in multiples of 5)</li>
              <li>Duration: HH:MM (maximum 05:00 hours, minutes must be multiples of 5)</li>
              <li>Panel Member IDs must be entered as comma-separated values (e.g., <code>1,2,3</code>)</li>
            </ul>
            <p class="format-note">
              <strong>Note:</strong> Use <code>'2026-01-01</code> / <code>'10:00 AM</code> / <code>'01:00</code>
              (starts with single quote) to avoid Excel auto-formatting for interview date, start time and duration.
            </p>
          </div>
        </div>

        <div class="section">
          <div class="checkbox-wrapper">
            <p-checkbox
              [(ngModel)]="bulkScheduleSendEmail"
              [binary]="true"
              inputId="bulkScheduleSendEmail">
            </p-checkbox>
            <label for="bulkScheduleSendEmail" class="checkbox-label">Send email notification to candidates</label>
          </div>
        </div>

        <div class="section" *ngIf="errorFileUrl">
          <div class="error-report">
            <h4 class="error-title">Error Report</h4>
            <button pButton type="button" label="Download Error Report" icon="pi pi-download"
              (click)="downloadErrorReport()" class="error-download-btn">
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button pButton pRipple type="submit" label="Submit" (click)="scheduleFileUpload()" class="send-invite-btn"
        [loading]="scheduleBtnLoading">
      </button>
    </div>
  </div>
</p-dialog>


<p-dialog [(visible)]="showTestScheduleSlider" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  styleClass="schedule-candidates-dialog" [style]="{width: '600px', maxWidth: '90vw'}" (onHide)="bulkTestSchedule()" class="neo-dialog">

  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">Bulk Test Schedule</h2>
      <button 
        type="button" 
        class="dialog-close-btn"
        (click)="showTestScheduleSlider = false"
        aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <div class="section">
          <label class="section-title">Download Template</label>
          <div class="template-download-card" (click)="downloadSampleTemplate()">
            <div class="template-info">
              <i class="pi pi-file-excel template-icon"></i>
              <div>
                <div class="template-name">Schedule Bulk Test.xlsx</div>
              </div>
            </div>
            <button class="download-btn" type="button">
              <i class="pi pi-download"></i>
            </button>
          </div>
        </div>

        <div class="section">
          <label class="section-title">Upload Template <span class="required">*</span></label>

          <div class="upload-area" *ngIf="!templateUploaded">
            <div class="dropzone" ngx-dropzone
              [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'"
              [multiple]="false" (change)="uploadTemplate($event)">
              <ngx-dropzone-label>
                <div class="dropzone-content">
                  <i class="pi pi-upload upload-icon"></i>
                  <p class="upload-text">
                    Drag & Drop your files here or <span class="upload-link">Choose Files</span>
                  </p>
                  <p class="upload-hint">Recommended: .XLSX</p>
                </div>
              </ngx-dropzone-label>
            </div>
          </div>

          <div *ngFor="let f of template">
            <div class="uploaded-file" *ngIf="f.name">
              <div class="file-info">
                <i class="pi pi-file-excel file-icon"></i>
                <div class="file-details">
                  <p class="file-name">{{f.name}}</p>
                  <p class="file-size">{{templateSize}}</p>
                </div>
              </div>
              <button 
              type="button" 
              class="remove-file-btn"
              (click)="onRemoveExcel()">
              <em class="pi pi-times"></em>
            </button>
            </div>
          </div>

          <p class="upload-note">The template should contain only the candidate_uuid field. Maximum invite upto {{ bulkSendTestLinkLimit | number }} candidates</p>
        </div>

        <div class="section" *ngIf="errorFileUrl">
          <div class="error-report">
            <h4 class="error-title">Error Report</h4>
            <button pButton type="button" label="Download Error Report" icon="pi pi-download"
              (click)="downloadErrorReport()" class="error-download-btn">
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button pButton pRipple type="submit" label="Submit" (click)="testScheduleFileUpload()" class="send-invite-btn"
        [loading]="testScheduleBtnLoading">
      </button>
    </div>
  </div>
</p-dialog>


<p-dialog [(visible)]="sendLinkSlider" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  styleClass="sendlink-dialog" [style]="{width: showAvailabilityPanel ? '850px' : '600px', maxWidth: '95vw'}" (onHide)="sidenavClosed()" class="neo-dialog">

  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">
        <span *ngIf="stage?.type === 'Online Interview' || stage?.type === 'AI Interview'">Schedule Interview</span>
        <span *ngIf="stage?.type === 'Offline Interview'">Schedule Interview</span>
      </h2>
      <button type="button" class="dialog-close-btn" (click)="sendLinkSlider = false" aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <form [formGroup]="sendLinkForm" (ngSubmit)="sendInterviewLink()" class="send-email-form">
          
          <div class="form-row two-columns">
            <div class="form-field neo-input-wrapper">
              <label class="field-label">Date <span class="required-asterisk">*</span></label>
              <p-datepicker 
                bigger
                iconDisplay="input"
                inputId="dateformat" 
                formControlName="interviewDate" 
                [showIcon]="true" 
                [minDate]="currentDate"
                [ngClass]="{'invalid': clicked && sendLinkForm.controls['interviewDate'].errors}"
                (onSelect)="dateChange(); onDateChangeForAvailability()"
                class="form-calendar"
                placeholder="Select Date"
                styleClass="full-width-calendar">
              </p-datepicker>
              <app-handle-error [clicked]="clicked" [control]="sendLinkForm.get('interviewDate')"
                name="Date"></app-handle-error>
            </div>

            <div class="form-field neo-input-wrapper">
              <label class="field-label">Start Time <span class="required-asterisk">*</span></label>
              <p-select 
                bigger
                class="form-dropdown"
                [options]="timeSlots" 
                formControlName="startTime" 
                optionLabel="formattedTime"
                [ngClass]="{'invalid': clicked && sendLinkForm.controls['startTime'].errors}"
                placeholder="Select Start Time"
                (onChange)="onStartTimeChangeForAvailability()">
                <ng-template let-slot pTemplate="item">
                  {{slot.formattedTime}}
                </ng-template>
              </p-select>
              <app-handle-error [clicked]="clicked" [control]="sendLinkForm.get('startTime')"
                name="Start Time"></app-handle-error>
            </div>
          </div>

          <div class="form-field neo-input-wrapper" *ngIf="stage?.type === 'Online Interview'">
            <label class="field-label">Interview Provider <span class="required-asterisk">*</span></label>
            <div class="provider-dropdown-wrapper">
              <p-select bigger class="form-dropdown provider-select" [options]="conferenceProviders"
                [(ngModel)]="selectedConferenceProvider" [ngModelOptions]="{standalone: true}" optionLabel="name"
                optionDisabled="selectDisabled"
                appendTo="body" placeholder="Select Interview Provider"
                panelStyleClass="provider-select-panel"
                (onShow)="loadConferenceProviders()" (onChange)="onProviderSelectChange()">
                <ng-template let-provider pTemplate="item">
                  <div class="provider-option" [class.disabled-provider]="!provider.is_integrated">
                    <div class="provider-option-left">
                      <i *ngIf="provider.key === 'default'" class="pi pi-video provider-option-icon-pi"></i>
                      <img *ngIf="provider.key !== 'default'" [src]="getProviderIcon(provider.key)" [alt]="provider.name"
                        class="provider-option-icon" />
                      <div class="provider-option-info">
                        <div class="provider-name-row">
                          <span class="provider-option-name">{{provider.name}}</span>
                          <span *ngIf="provider.key === 'default'" class="provider-default-tag">Recommended</span>
                        </div>
                        <span class="provider-option-status" [class.connected]="provider.is_integrated"
                          [class.not-connected]="!provider.is_integrated">
                          {{provider.is_integrated ? 'Connected' : 'Not Connected'}}
                        </span>
                      </div>
                    </div>
                    <button *ngIf="!provider.is_integrated && userPrivileges.has('integration.update')" type="button" class="provider-connect-btn"
                      (click)="navigateToSettings(); $event.stopPropagation()">
                      Connect
                    </button>
                    <i *ngIf="provider.is_integrated" class="pi pi-check-circle provider-connected-icon"></i>
                  </div>
                </ng-template>
                <ng-template let-provider pTemplate="selectedItem">
                  <div class="provider-selected" *ngIf="provider">
                    <i *ngIf="provider.key === 'default'" class="pi pi-video provider-selected-icon-pi"></i>
                    <img *ngIf="provider.key !== 'default'" [src]="getProviderIcon(provider.key)" [alt]="provider.name"
                      class="provider-selected-icon" />
                    <span>{{provider.name}}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="footer">
                  <div class="provider-loading-row" *ngIf="isLoadingProviders">
                    <p-progressSpinner [style]="{width: '18px', height: '18px'}" strokeWidth="5"
                      animationDuration="0.5s"></p-progressSpinner>
                  </div>
                </ng-template>
              </p-select>
            </div>
          </div>

          <div class="form-field neo-input-wrapper" *ngIf="stage?.type === 'Online Interview'">
            <label class="field-label">Interviewer(s) <span class="required-asterisk">*</span></label>
            
            <div class="selected-interviewers-tags" *ngIf="selectedInterviewers.length > 0">
              <div class="interviewer-tag" *ngFor="let interviewerId of selectedInterviewers">
                <span class="interviewer-avatar" [style.background-color]="getInterviewerAvatarColor(interviewerId)">
                  {{getInterviewerInitials(interviewerId)}}
                </span>
                <span class="interviewer-tag-name">{{getInterviewerName(interviewerId)}}</span>
                <button type="button" class="interviewer-tag-remove" (click)="removeInterviewer(interviewerId)">
                  <i class="pi pi-times"></i>
                </button>
              </div>
            </div>

            <p-multiselect 
              bigger
              class="form-dropdown interviewer-multiselect"
              [options]="interviewerList" 
              [(ngModel)]="selectedInterviewers"
              [ngModelOptions]="{standalone: true}"
              optionLabel="label"
              optionValue="value"
              [selectionLimit]="4"
              placeholder="Select Interviewer (Max 4)"
              appendTo="body"
              (onPanelShow)="onInterviewerPanelShow($event)"
              (onChange)="onInterviewerChangeForAvailability()">
            </p-multiselect>

            <button type="button" class="view-availability-link" 
              *ngIf="selectedConferenceProvider?.key === 'ms_teams' && selectedInterviewers.length > 0"
              (click)="toggleAvailabilityPanel()">
              {{showAvailabilityPanel ? 'Hide availability' : 'View availability'}}
            </button>
          </div>

          <div class="availability-panel" *ngIf="showAvailabilityPanel && selectedConferenceProvider?.key === 'ms_teams' && selectedInterviewers.length > 0">
            <div class="availability-header">
              <div class="availability-header-left">
                <i class="pi pi-calendar"></i>
                <span class="availability-date">{{getFormattedAvailabilityDate()}}</span>
              </div>
              <div class="availability-header-nav" *ngIf="!isLoadingAvailability && availabilityData.length > 0">
                <button type="button" class="timeline-nav-btn" (click)="scrollTimelineLeft()" [disabled]="timelineScrollOffset === 0">
                  <i class="pi pi-chevron-left"></i>
                </button>
                <button type="button" class="timeline-nav-btn" (click)="scrollTimelineRight()" [disabled]="timelineScrollOffset + visibleSlotsCount >= allTimeSlots.length">
                  <i class="pi pi-chevron-right"></i>
                </button>
              </div>
            </div>

            <div class="availability-loading" *ngIf="isLoadingAvailability">
              <p-progressSpinner [style]="{width: '30px', height: '30px'}" strokeWidth="4"></p-progressSpinner>
              <span>Loading availability...</span>
            </div>

            <div class="availability-timeline" *ngIf="!isLoadingAvailability && availabilityData.length > 0">
              <div class="timeline-container">
                <div class="timeline-names-column">
                  <div class="timeline-names-header"></div>
                  <div class="timeline-name-cell" *ngFor="let interviewer of availabilityData; trackBy: trackByIndex">
                    <span class="interviewer-avatar-sm" [style.background-color]="getInterviewerAvatarColor(interviewer.id)">
                      {{getInterviewerInitials(interviewer.id)}}
                    </span>
                    <span class="interviewer-name-text" [title]="interviewer.name">{{interviewer.name}}</span>
                  </div>
                </div>

                <div class="timeline-slots-wrapper">
                  <div class="timeline-slots-scroll">
                    <div class="timeline-time-headers">
                      <div class="time-header-cell" *ngFor="let slot of visibleTimeSlots; trackBy: trackByIndex"
                        [class.selected-time]="isSlotSelected(slot)">
                        {{formatTimeSlot(slot)}}
                      </div>
                    </div>
                    <div class="timeline-slots-body">
                      <div class="timeline-slots-row" *ngFor="let interviewer of availabilityData; trackBy: trackByIndex">
                        <div class="slot-cell" *ngFor="let slot of visibleTimeSlots; let i = index; trackBy: trackByIndex">
                          <button type="button" class="slot-btn"
                            [class.available]="isSlotAvailable(interviewer, i + timelineScrollOffset)"
                            [class.busy]="!isSlotAvailable(interviewer, i + timelineScrollOffset)"
                            [class.selected]="isSlotSelected(slot)"
                            [class.common-available]="isCommonAvailableSlot(i + timelineScrollOffset)"
                            [disabled]="!isCommonAvailableSlot(i + timelineScrollOffset)"
                            (click)="selectTimeSlot(slot)">
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="availability-legend">
                <div class="legend-item">
                  <div class="legend-color available"></div>
                  <span>Available</span>
                </div>
                <div class="legend-item">
                  <div class="legend-color busy"></div>
                  <span>Busy</span>
                </div>
                <div class="legend-item">
                  <div class="legend-color selected"></div>
                  <span>Selected</span>
                </div>
              </div>
            </div>

            <div class="availability-empty" *ngIf="!isLoadingAvailability && availabilityData.length === 0">
              <i class="pi pi-calendar-times"></i>
              <span>Select a date and time to view availability</span>
            </div>
          </div>

          <div class="form-row two-columns">
            <div class="form-field neo-input-wrapper">
              <label class="field-label">Duration <span class="required-asterisk">*</span></label>
              <p-select 
                bigger
                class="form-dropdown"
                [options]="getDurationSlots()" 
                formControlName="duration"
                appendTo="body"
                [ngClass]="{'invalid': clicked && sendLinkForm.controls['duration'].errors}"
                placeholder="Select Duration">
                <ng-template let-slot pTemplate="item">
                  {{slot.label}}
                </ng-template>
              </p-select>
              <app-handle-error [clicked]="clicked" [control]="sendLinkForm.get('duration')"
                name="Duration"></app-handle-error>
            </div>

            <div class="form-field neo-input-wrapper">
              <label class="field-label">Job Role <span class="required-asterisk">*</span></label>
              <p-select 
                bigger
                class="form-dropdown"
                [options]="interviewJobRoles" 
                formControlName="jobRoleId"
                [ngClass]="{'invalid': clicked && sendLinkForm.controls['jobRoleId'].errors}"
                appendTo="body"
                placeholder="Select Job Role">
                <ng-template let-role pTemplate="item">
                  {{role.label}}
                </ng-template>
              </p-select>
              <app-handle-error [clicked]="clicked" [control]="sendLinkForm.get('jobRoleId')"
                name="Job Role"></app-handle-error>
            </div>
          </div>

          <div class="form-field neo-input-wrapper" *ngIf="stage?.type === 'Offline Interview'">
            <label class="field-label">Venue <span class="required-asterisk">*</span></label>
            <input 
              bigger
              pInputText 
              type="text" 
              formControlName="venue"
              [ngClass]="{'invalid': clicked && sendLinkForm.controls['venue'].errors}"
              class="form-input"
              placeholder="Enter venue">
            <app-handle-error [clicked]="clicked" [control]="sendLinkForm.get('venue')" name="Venue"></app-handle-error>
          </div>

          <div class="form-field neo-input-wrapper interviewer-field-wrapper" *ngIf="stage?.type === 'Offline Interview'">
            <label class="field-label">Interviewer(s) <span class="required-asterisk">*</span></label>
            <p-multiselect 
              bigger
              class="form-dropdown interviewer-multiselect"
              [options]="interviewerList" 
              [(ngModel)]="selectedInterviewers"
              [ngModelOptions]="{standalone: true}"
              optionLabel="label"
              optionValue="value"
              [selectionLimit]="4"
              placeholder="Select Interviewer (Max 4)"
              [panelStyleClass]="'interviewer-dropdown-panel-up'"
              (onPanelShow)="onInterviewerPanelShow($event)">
            </p-multiselect>
          </div>

          <!-- 6. Send Email Checkbox (Only for Offline Interview) -->
          <div class="form-field" *ngIf="(stage?.type === 'Offline Interview' || stage?.type === 'Online Interview') && !isExternalProviderSelected">
            <div class="checkbox-wrapper">
              <p-checkbox 
                formControlName="sendEmail" 
                [binary]="true" 
                inputId="sendEmail">
              </p-checkbox>
              <label for="sendEmail" class="checkbox-label">Send email notification to candidate</label>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button 
        pButton 
        pRipple 
        type="submit" 
        label="Send Slot" 
        class="send-invite-btn" 
        [loading]="uploadBtnLoading"
        (click)="sendInterviewLink()">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog class="activity-dialog" [(visible)]="stageActivitySlider" [modal]="true" [closable]="false" [draggable]="false"
  [resizable]="false" (onHide)="onHideActivity()" styleClass="activity-dialog-container"
  [style]="{width: '600px'}" class="neo-dialog">

  <div class="dialog-wrapper">
    <!-- Header -->
    <div class="dialog-header">
      <h2 class="dialog-title">{{activitySliderOptions.header}}</h2>
      <button 
        type="button" 
        class="dialog-close-btn"
        (click)="onHideActivity()"
        aria-label="Close">
        <em class="pi pi-times"></em>
      </button>
    </div>

    <!-- Content -->
    <div class="dialog-content">
      <div class="content-wrapper">
        <div class="activity-content">
          <div class="info-section">
            <div class="info-item">
              <label class="field-label">Selected</label>
              <div class="info-value">
                {{selectedAllStageCandidates ? totalLength : selectedUsersList.length}}
                Candidate{{ selectedAllStageCandidates || selectedUsersList.length > 1 ? 's' : ''}}
              </div>
            </div>

            <div class="info-item">
              <label class="field-label">{{activitySliderOptions.action == 'moveStage' ? 'Stage' : 'Status'}}</label>
              <div class="stage-movement">
                <span *ngIf="activitySliderOptions?.action !== 'statusUpdate' || selectedUsersList.length == 1"
                  class="from-stage">{{activitySliderOptions.from}}</span>
                <img *ngIf="activitySliderOptions?.action !== 'statusUpdate' || selectedUsersList.length == 1"
                  src="../../../assets/icons-svg/arrow-right-alt.svg" alt="Arrow-right" class="arrow-icon">
                <span class="to-stage">{{activitySliderOptions.to}}</span>
              </div>
            </div>
          </div>

          <div class="form-field" *ngIf="showJoiningDate == 'joined'">
            <label class="field-label">Joining Date <span class="required-asterisk">*</span></label>
            <p-datepicker 
              inputId="joiningDate" 
              [showIcon]="true" 
              [readonlyInput]="true"
              (onSelect)="joinDateSelection($event)" 
              placeholder="Select Date" 
              class="form-calendar">
            </p-datepicker>
          </div>

          <div class="form-field">
            <label class="field-label">Remarks</label>
            <textarea 
              [(ngModel)]="activityRemarks" 
              placeholder="Type remark here" 
              id="remarks" 
              class="remarks-textarea"
              rows="6" 
              pInputTextarea>
            </textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
      <button 
        pButton 
        pRipple 
        type="submit" 
        label="Submit" 
        class="send-invite-btn" 
        [loading]="uploadBtnLoading"
        (click)="activitySliderSubmit(activitySliderOptions)">
      </button>
    </div>
  </div>
</p-dialog>

<div class="stage-candidates-container">

  <p-drawer styleClass="settingsSidebar" [transitionOptions]="'300ms'" [(visible)]="showSettingsSidebar" [modal]="false"
    position="right" [showCloseIcon]="false" [baseZIndex]="1000">

    <div class="settings-sidebar-header">
      <h3 class="settings-sidebar-title">Column Settings</h3>
    </div>
    <div class="settings-sidebar-center">
      <div class="settings-content-container">

        <div class="settings-search-container">
          <i class="pi pi-search"></i>
          <input type="text" class="settings-search-input" placeholder="Search" [(ngModel)]="columnSearchTerm"
            (ngModelChange)="searchColumns($event)" />
        </div>


        <div class="settings-columns-section">
          <div class="settings-column-item" *ngFor="let col of _candidatesCol; trackBy: trackByIndex">
            <div class="column-item-left">
              <p-checkbox name="category" [value]="col" [(ngModel)]="checkedColumns" [inputId]="col.field === 'testScore' ? col.field + '_' + col.stageId : col.field">
              </p-checkbox>
              <label [for]="col.field === 'testScore' ? col.field + '_' + col.stageId : col.field" class="settings-column-label">{{col.header}}</label>
            </div>
            <i class="fas fa-grip-vertical drag-handle"></i>
          </div>
        </div>
      </div>
    </div>


    <div class="settings-actions">
      <button pButton class="settings-cancel-btn" label="Cancel" [outlined]="true" (click)="showSettingsSidebar = false; resetCheckedColumnsToDefault()">
      </button>
      <button pButton class="settings-apply-btn" label="Apply" (click)="applySelectedColumns()">
      </button>
    </div>
  </p-drawer>


  <p-drawer styleClass="downloadSidebar candidateListDownload" [transitionOptions]="'300ms'"
    [(visible)]="showDownloadSidebar" [modal]="false" position="right" [showCloseIcon]="false" [baseZIndex]="1000">


    <div class="download-sidebar-header">
      <div class="header-top-row">
        <h3 class="download-sidebar-title">Download Stage Data</h3>
        <div class="format-toggle">
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'csv'}" (click)="downloadAs = 'csv'">
              <i class="pi pi-check" *ngIf="downloadAs === 'csv'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'csv'">CSV</span>
          </div>
          <div class="format-option">
            <div class="format-radio" [ngClass]="{'active': downloadAs === 'excel'}" (click)="downloadAs = 'excel'">
              <i class="pi pi-check" *ngIf="downloadAs === 'excel'"></i>
            </div>
            <span class="format-label" (click)="downloadAs = 'excel'">EXCEL</span>
          </div>
        </div>
      </div>
    </div>


    <div class="download-sidebar-content">
      <div class="download-columns-section">
        <div class="download-column-item select-all-item">
          <p-checkbox [(ngModel)]="selectAllColumns" (onChange)="toggleSelectAll()" [binary]="true" inputId="selectAll">
          </p-checkbox>
          <label for="selectAll" class="download-column-label">Select All</label>
        </div>


        <div class="download-column-item" *ngFor="let col of colsToDownload; trackBy: trackByIndex">
          <p-checkbox name="downloadColumns" [value]="col" [(ngModel)]="checkedColumns" [inputId]="col.field === 'testScore' ? col.field + '_' + col.stageId : col.field"
            (onChange)="onColumnCheckChange()">
          </p-checkbox>
          <label [for]="col.field === 'testScore' ? col.field + '_' + col.stageId : col.field" class="download-column-label">{{col.header}}</label>
        </div>
      </div>
    </div>


    <div class="download-actions">
      <div class="download-buttons-row">
        <button pButton class="cancel-btn" [outlined]="true" label="Cancel" (click)="showDownloadSidebar = false; resetCheckedColumnsToDefault()">
        </button>
        <button pButton  label="Download" [disabled]="checkedColumns.length === 0"
          (click)="(downloadAs === 'excel') ? exportCandidate('excel') : exportCandidate('csv')">
        </button>
      </div>

      <div class="download-all-section">
        <button pButton [outlined]="true" class="download-all-candidates-btn" [disabled]="loadingDownload"
          (click)="exportAllCandidates(downloadAs)"
          [label]="loadingDownload ? 'Downloading...' : 'Download All Candidates'">
        </button>
      </div>
    </div>
  </p-drawer>


  <p-drawer *ngIf="showFilterSidebar" styleClass="filter-sidebar-v2" [transitionOptions]="'300ms'" [modal]="false" [baseZIndex]="1000"
    ariaCloseLabel="Filter" [(visible)]="showFilterSidebar" position="right" [showCloseIcon]="false">


    <div class="filter-sidebar-v2-header">
      <h3 class="filter-sidebar-v2-title">Filter</h3>
    </div>


    <div class="filter-sidebar-v2-content">

      <p-accordion [multiple]="true" [collapseIcon]="'pi pi-minus'"
        [(value)]="activeTabIndex">
        @for (col of _selectedColumns; track $index) {
        <p-accordion-panel [ngSwitch]="col.field" *ngIf="col.options" [value]="$index">
          <p-accordion-header>{{col.header}}</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr class="statusFilter" [style]="{width: '100%'}" [options]="col.options" id="filterOption"
                  [(ngModel)]="col.selectedFilterElement"
                (ngModelChange)="filterUpdate($event.value, col.field)" optionLabel="label">
              </p-select>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
        }

        <p-accordion-panel [value]="_selectedColumns.length" style="margin-top: 6px;" *ngIf="stage.type == 'OnBoarding'">
          <p-accordion-header>Joining Date</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-datepicker big nobg smbr [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" [inline]="true"
                [showWeek]="true" [style]="{width: 'auto'}" inputId="range" placeholder="Select joining date range"></p-datepicker>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['isPWD']" [value]="_selectedColumns.length + 1">
          <p-accordion-header>PWD</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr *ngIf="filterFieldTypes['isPWD'] === 'dropdown'" class="statusFilter" [style]="{width: '100%'}"
                [options]="pwdList" id="filterOption"  [(ngModel)]="selectedPwd" [showClear]="true"
                optionLabel="label" optionValue="value" (ngModelChange)="filterUpdate($event, 'isPWD')" placeholder="Select PWD status">
              </p-select>
              <input big nobg smbr *ngIf="filterFieldTypes['isPWD'] === 'input'" pInputText type="text" [(ngModel)]="selectedPwdText"
                placeholder="Enter PWD status" (ngModelChange)="filterUpdate($event, 'isPWD')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['jobRole']" [value]="_selectedColumns.length + 2">
          <p-accordion-header>Role</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr
              *ngIf="filterFieldTypes['jobRole'] === 'dropdown'"
              class="statusFilter"
              [style]="{width: '100%'}"
              [options]="roleList"
              [(ngModel)]="selectedRole"
              optionLabel="label"
              optionValue="value"
              (ngModelChange)="filterUpdate($event, 'jobRole')"
              placeholder="Select roles"
              #jobRoleEl
              [panelStyle]="{
                  'min-width': jobRoleEl.el.nativeElement.offsetWidth + 'px',
                  'max-width': jobRoleEl.el.nativeElement.offsetWidth + 'px'
              }">
            </p-multiselect>
              <input big nobg smbr *ngIf="filterFieldTypes['jobRole'] === 'input'" pInputText type="text" [(ngModel)]="selectedRoleText"
                placeholder="Enter job role" (ngModelChange)="filterUpdate($event, 'jobRole')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>

         <p-accordion-panel *ngIf="filterFieldVisibility['arrears']" [value]="_selectedColumns.length + 3">
          <p-accordion-header>Arrears</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr *ngIf="filterFieldTypes['arrears'] === 'dropdown'" class="statusFilter" [style]="{width: '100%'}"
                [options]="arrearList" id="filterOption"  [(ngModel)]="selectedArrears" [showClear]="true"
                optionLabel="label" optionValue="value" (ngModelChange)="filterUpdate($event, 'arrears')" placeholder="Select arrear status">
              </p-select>
              <input big nobg smbr *ngIf="filterFieldTypes['arrears'] === 'input'" pInputText type="text"
                [(ngModel)]="selectedArrearsText" placeholder="Enter arrears status"
                (ngModelChange)="filterUpdate($event, 'arrears')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['gender']" [value]="_selectedColumns.length + 4">
          <p-accordion-header>Gender</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-select big nobg smbr *ngIf="filterFieldTypes['gender'] === 'dropdown'" class="statusFilter" [style]="{width: '100%'}"
                [options]="genderList" id="filterOption"  [(ngModel)]="selectedGender"
                optionLabel="label" optionValue="value" (ngModelChange)="filterUpdate($event, 'gender')" placeholder="Select gender" [showClear]="true">
              </p-select>
              <input big nobg smbr *ngIf="filterFieldTypes['gender'] === 'input'" pInputText type="text" [(ngModel)]="selectedGenderText"
                placeholder="Enter gender" (ngModelChange)="filterUpdate($event, 'gender')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['graduationYear']" [value]="_selectedColumns.length + 5">
          <p-accordion-header>Graduation Year</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-datepicker big nobg smbr [(ngModel)]="selectedYearDate" [view]="'year'" [dateFormat]="'yy'" [showClear]="true"
                 (onSelect)="onYearSelected($event)" placeholder="Select graduation year">
              </p-datepicker>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['degree']" [value]="_selectedColumns.length + 5">
          <p-accordion-header>Degree</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr *ngIf="filterFieldTypes['degree'] === 'dropdown'" class="multi-talent branch-talent"
                [style]="{'width':'100%'}" [options]="degreeList" [(ngModel)]="selectedDegree" id="chips" display="chip" [maxSelectedLabels]="1"
                [filter]="true" optionLabel="label" optionValue="value" (ngModelChange)="filterUpdate($event, 'degree')" placeholder="Select degree"
                #degreeFilter
                [panelStyle]="{
                    'min-width': degreeFilter.el.nativeElement.offsetWidth + 'px',
                    'max-width': degreeFilter.el.nativeElement.offsetWidth + 'px'
                }">
              </p-multiselect>
              <input big nobg smbr *ngIf="filterFieldTypes['degree'] === 'input'" pInputText type="text"
                [(ngModel)]="selectedDegreeText" placeholder="Enter degree"
                (ngModelChange)="filterUpdate($event, 'degree')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['degreeBranch']" [value]="_selectedColumns.length + 6">
          <p-accordion-header>Specialization</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr *ngIf="filterFieldTypes['degreeBranch'] === 'dropdown'" class="multi-talent branch-talent"
                [style]="{'width':'100%'}" [options]="branchList" [(ngModel)]="selectedBranch" id="chips" display="chip" [maxSelectedLabels]="1"
                optionLabel="label" optionValue="value" (ngModelChange)="filterUpdate($event, 'degreeBranch')" placeholder="Select specialization"
                #degreeBranch
                [panelStyle]="{
                    'min-width': degreeBranch.el.nativeElement.offsetWidth + 'px',
                    'max-width': degreeBranch.el.nativeElement.offsetWidth + 'px'
                }">
              </p-multiselect>
              <input big nobg smbr *ngIf="filterFieldTypes['degreeBranch'] === 'input'" pInputText type="text"
                [(ngModel)]="selectedBranchText" placeholder="Enter specialization"
                (ngModelChange)="filterUpdate($event, 'degreeBranch')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <p-accordion-panel *ngIf="filterFieldVisibility['collegeName']" [value]="_selectedColumns.length + 7">
          <p-accordion-header>College</p-accordion-header>
          <p-accordion-content>
            <div class="neo-input-wrapper">
              <p-multiselect big nobg smbr *ngIf="filterFieldTypes['collegeName'] === 'dropdown'" class="multi-talent college-talent" (onPanelShow)="onInstitutionDropdownShow($event, collegeName)" (onPanelHide)="onInstitutionDropdownHide($event)"
                [style]="{'width':'100%'}" [options]="collegeList" [(ngModel)]="selectedCollege" id="chips" display="chip" [maxSelectedLabels]="1" (onFilter)="filterInstitute($event)" [emptyFilterMessage]="loadingInstitutions ? 'Searching...' : 'No results found'"
                optionLabel="label" optionValue="value" (ngModelChange)="filterUpdate($event, 'collegeName')" placeholder="Select college name"
                #collegeName appendTo="body" [overlayOptions]="{styleClass: 'overflow-auto overflow-normal'}"
                [panelStyle]="{
                    'min-width': collegeName.el.nativeElement.offsetWidth + 'px',
                    'max-width': collegeName.el.nativeElement.offsetWidth + 'px'
                }">
              </p-multiselect>
              <input big nobg smbr *ngIf="filterFieldTypes['collegeName'] === 'input'" pInputText type="text"
                [(ngModel)]="selectedCollegeText" placeholder="Enter college name"
                (ngModelChange)="filterUpdate($event, 'collegeName')" [style]="{width: '100%'}">
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>


    <div class="filter-actions">
      <div class="filter-buttons-row">
        <button pButton class="filter-cancel-btn" [outlined]="true" label="Cancel" (click)="cancelFilter()">
        </button>
        <button pButton class="filter-cancel-btn" [outlined]="true" label="Clear" type="button" (click)="clearSelectedFilters()">
        </button>
        <button pButton class="filter-apply-btn" label="Apply" [loading]="filterLoading"
          (click)="applySelectedFilter()">
        </button>
      </div>
    </div>
  </p-drawer>


  <div class="filter-tabs-container">
    <div class="filter-tabs">
      <!-- Normal view - All Candidates tab -->
      <div class="filter-tab active" *ngIf="selectedUsersList.length === 0">
        All Candidates
        <span class="candidate-count">{{ totalLength || 0 }}</span>
      </div>

      <!-- Selection Actions - shown when candidates are selected -->
      <div class="selection-actions-row" *ngIf="selectedUsersList.length > 0 && !loadingSpinner">
        <span class="selected-count-label">
          {{selectedAllStageCandidates ? totalLength : selectedUsersList.length}} Selected
        </span>
        <button pButton class="action-btn" *ngIf="userPrivileges.has('event_candidate.move_stage')" [ngClass]="{'active': stagesOP.overlayVisible}" label="Move Stage"
          (click)="stagesOP.toggle($event)"></button>
        <button pButton class="action-btn" label="Send Email" *ngIf="userPrivileges.has('event_candidate.send_mail')"
          (click)="sendMailHeader = 'Send Email'; sendEmail()"></button>
        <button pButton class="action-btn" *ngIf="userPrivileges.has('event_candidate.update_status')" [ngClass]="{'active': statusOP.overlayVisible}" label="Change Status"
          (click)="statusOP.toggle($event)"></button>

        <!-- Conditional buttons based on stage type -->
        <button pButton class="action-btn" *ngIf="stage?.type === 'Assessment' && userPrivileges.has('event_candidate.send_test_link')"
          [label]="stage?.is_walk_in ? 'Schedule Assessment' : 'Send Test Link'"
          [disabled]="selectedAllStageCandidates" (click)="handleSendTestLink()"></button>
        <button pButton class="action-btn" *ngIf=" userPrivileges.has('event_candidate.send_interview_link') && userPrivileges.has('event_stage_candidate.schedule_interview') && (stage?.type === 'Online Interview' || stage?.type === 'AI Interview')"
          label="Schedule Interview" [disabled]="selectedAllStageCandidates"
          (click)="(stage?.type === 'AI Interview' || stage.form?.uuid) && (sendLinkSlider = true)"></button>
        <button pButton class="action-btn" *ngIf="stage?.type === 'Online Interview' && userPrivileges.has('event_stage_candidate.bulk_action') && userPrivileges.has('event_stage_candidate.schedule_interview')"
          label="Bulk Schedule" (click)="showScheduleSlider = true"></button>
        <button pButton class="action-btn" *ngIf="stage?.type === 'Offline Interview' && userPrivileges.has('event_candidate.send_interview_link') && userPrivileges.has('event_stage_candidate.schedule_interview')" label="Schedule Interview"
          [disabled]="selectedAllStageCandidates" (click)="stage.form?.uuid && (sendLinkSlider = true)"></button>
        <button pButton class="action-btn" *ngIf=" userPrivileges.has('event_candidate.send_documentation_link') && stage?.type === 'Documentation'" label="Send Documentation Link"
          [disabled]="selectedAllStageCandidates"
          (click)="sendDocumentation = true; sendMailHeader = 'Send Documentation'; sendEmail()"></button>
        <button pButton class="action-btn" *ngIf=" userPrivileges.has('event_candidate.send_offer') && stage?.type === 'Offer'" label="Send Offer"
          [disabled]="selectedAllStageCandidates"
          (click)="sendOfferMail = true; sendMailHeader = 'Send Offer'; sendEmail()"></button>
      </div>
    </div>


    <div class="table-controls" *ngIf="selectedUsersList.length === 0">
      <button pButton class="control-btn"
        *ngIf="stage?.type === 'Assessment' && userPrivileges.has('event_stage_candidate.bulk_action')" pTooltip="Sync scores"
        tooltipPosition="top" (click)="confirmSyncScores()" [disabled]="syncScoresLoading">
        <img src="assets/icons-svg/sync.svg" alt="Sync Scores" />
      </button>
      <button pButton class="control-btn" *ngIf="stage?.type === 'Assessment' && userPrivileges.has('event_stage_candidate.bulk_action')"
        pTooltip="Sync Test Details" tooltipPosition="top" (click)="confirmSyncContest()"
        [disabled]="syncContestLoading">
        <img src="assets/icons-svg/timer.svg" alt="Sync Test Details" />
      </button>
      <button pButton class="control-btn" pTooltip="Column Settings" tooltipPosition="top"
        (click)="showSettingsSidebar = true; showFilterSidebar = false; showDownloadSidebar = false">
        <img src="assets/icons-svg/column-setting.svg" alt="Settings" />
      </button>
      <button pButton class="control-btn" pTooltip="Filter" tooltipPosition="top"
        (click)="showFilterSidebar = true; showSettingsSidebar = false; showDownloadSidebar = false; filterShow()">
        <img src="assets/icons-svg/filter.svg" alt="Filter" />
        <span *ngIf="getActiveFilterCounts" class="count-badge">
          {{getActiveFilterCounts}}
        </span>
      </button>
      <button pButton class="control-btn" *ngIf="userPrivileges.has('event_stage_candidate.export')" pTooltip="Download"
        tooltipPosition="top"
        (click)="showDownloadSidebar = true; showSettingsSidebar = false; showFilterSidebar = false">
        <img src="assets/icons-svg/download.svg" alt="Download" />
      </button>
      <button pButton class="control-btn"
        *ngIf="userPrivileges.has('event_stage_candidate.import') && stage?.type !== 'AI Interview'"
        pTooltip="Upload Candidates" tooltipPosition="top" (click)="showUploadSlider = true">
        <img src="assets/icons-svg/upload.svg" alt="Upload" />
      </button>
      <button pButton class="control-btn" *ngIf="stageType == 'Online Interview' && (userPrivileges.has('event_stage_candidate.bulk_action') || userPrivileges.has('event_candidate.send_interview_link') || userPrivileges.has('event_stage_candidate.schedule_interview'))" pTooltip="Bulk Schedule"
        tooltipPosition="top" (click)="showScheduleSlider = true">
        <img src="assets/icons-svg/calendar.svg" alt="Schedule" />
      </button>
      <button pButton class="control-btn" *ngIf=" userPrivileges.has('event_candidate.send_test_link') && stage?.type == 'Assessment'" pTooltip="Bulk Schedule" tooltipPosition="top"
        (click)="showTestScheduleSlider = true">
        <img src="assets/icons-svg/calendar.svg" alt="Schedule" />
      </button>
      <button pButton class="control-btn" pTooltip="Refresh" tooltipPosition="top" (click)="getCandidates()">
        <img src="assets/icons-svg/refresh.svg" alt="Refresh" />
      </button>
      <span class="table-menu">
        <p-select class="view-list-dropdown" [options]="pageLimits" [(ngModel)]="pageSize"
          (onChange)="getUsersByLimit()">
        </p-select>
        <button pButton (click)="prev()" [disabled]="isFirstPage() || loadingSpinner"
          class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-left.svg" alt="Previous" class="icon-svg">
        </button>
        <button pButton class="disabled p-button-secondary p-button-text simple-btn">{{ loadingSpinner ? '...' :
          pageNumber + ' of ' + totalPages }}</button>
        <button pButton (click)="next()" [disabled]="isLastPage() || loadingSpinner"
          class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-right.svg" alt="Next" class="icon-svg">
        </button>
      </span>
    </div>
  </div>


  <div class="main-table-container">
    <p-table #dt [columns]="_selectedColumns" [value]="loadingSpinner ? skeletonData : candidateList"
      [resizableColumns]="true" [rows]="pageSize" [loading]="false" [scrollable]="true" scrollDirection="both"
      responsiveLayout="scroll" dataKey="id" [(selection)]="selectedUsersList" [customSort]="true"
      (selectionChange)="handleSelection($event)" (sortFunction)="customSort($event)" [exportFilename]="exportName" styleClass="modern-table">

      <ng-template pTemplate="header" let-columns>
        <tr class="modern-table-header"
          [ngClass]="{'moveTable': showFilterSidebar || showSettingsSidebar || showDownloadSidebar}">
          <th scope="col" class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container" *ngIf="candidateList.length && !loadingSpinner">
              <p-tableHeaderCheckbox [disabled]="loadingSpinner"></p-tableHeaderCheckbox>
            </div>
          </th>
          <th class="candidate-name-column" scope="col" pResizableColumn pFrozenColumn pSortableColumn="name">
            CANDIDATE NAME
            <p-sortIcon class="sort-icon" field="name"></p-sortIcon>
          </th>
          <th [style]="{width: '11vw'}" scope="col" pSortableColumn="{{ col.sortable ? col.field : null }}"
            *ngFor="let col of columns; trackBy: trackByIndex" pResizableColumn>
            {{ col.header }}
            <p-sortIcon *ngIf="col.sortable" class="sort-icon" field="{{ col.field }}"></p-sortIcon>
          </th>
        </tr>


      </ng-template>


      <ng-template pTemplate="body" let-candidate let-columns="columns">
        <tr class="modern-table-row"
          [ngClass]="{'moveTable': showFilterSidebar || showSettingsSidebar || showDownloadSidebar, 'skeleton-row': loadingSpinner}"
          [style]="{cursor: loadingSpinner ? 'default' : 'pointer'}">
          <td class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container">
              <ng-container *ngIf="!loadingSpinner; else skeletonCheckbox">
                <p-tableCheckbox [value]="candidate"></p-tableCheckbox>
              </ng-container>
              <ng-template #skeletonCheckbox>
                <div class="skeleton skeleton-checkbox"></div>
              </ng-template>
            </div>
          </td>


          <td (click)="!loadingSpinner && showCandidateDetails(candidate)" class="candidate-name-column" pFrozenColumn>
            <ng-container *ngIf="!loadingSpinner; else skeletonText">
              <div class="candidate-info">
                <div class="candidate-avatar" [style.background-color]="getAvatarColor(candidate.name)">

                  <img *ngIf="hasValidPhoto(candidate)" [src]="candidate.photo" [alt]="candidate.name"
                    class="candidate-photo" (error)="onImageError($event, candidate)" (load)="onImageLoad($event)" />

                  <span class="candidate-initials" [style.display]="hasValidPhoto(candidate) ? 'none' : 'flex'">
                    {{ getInitials(candidate.name) }}
                  </span>
                </div>
                <div class="candidate-details">
                  <span class="candidate-name">{{ candidate.name }}</span>
                  <span class="candidate-id" 
                        (click)="$event.stopPropagation(); copyToClipboard(candidate.id, 'Candidate ID')"
                        (keydown.enter)="copyToClipboard(candidate.id, 'Candidate ID')"
                        (keydown.space)="copyToClipboard(candidate.id, 'Candidate ID')"
                        title="Click to copy Candidate ID"
                        role="button"
                        tabindex="0"
                        [attr.aria-label]="'Candidate ID: ' + getTruncatedId(candidate.id) + '. Click to copy to clipboard'">
                    {{ getTruncatedId(candidate.id) }}
                  </span>
                </div>
                
              </div>
            </ng-container>
            <ng-template #skeletonText>
              <div class="skeleton skeleton-text skeleton-text-long"></div>
            </ng-template>
          </td>

          <td *ngFor="let col of columns; trackBy: trackByIndex" (click)="!loadingSpinner && showCandidateDetails(candidate)"
            [style]="{width: '11vw'}">
            <ng-container *ngIf="!loadingSpinner; else skeletonCell">
              <span [ngSwitch]="true" class="box-data">

                <span *ngSwitchCase="col.field === 'status'">
                  <span class="modern-status-badge" [ngClass]="getStatusClass(candidate[col.field])">
                    {{candidate[col.field]}}
                  </span>
                </span>


                <span *ngSwitchCase="col.field === 'collegeName'">
                  <span [pTooltip]="candidate[col.field]" tooltipPosition="top" tooltipStyleClass="custom-tooltip"
                    class="college-names-text">
                    {{ candidate[col.field] ? candidate[col.field] : '-' }}
                  </span>
                </span>


                <span *ngSwitchCase="col.field === 'email'">
                  <span [pTooltip]="candidate[col.field]" tooltipPosition="top" tooltipStyleClass="custom-tooltip"
                    class="college-names-text">
                    {{ candidate[col.field] ? candidate[col.field] : '-' }}
                  </span>
                </span>


                <span *ngSwitchCase="col.field === 'testScore'">
                  <ng-container *ngIf="getStageIdFromColumn(col) as stageId">
                    <span *ngIf="getTestScoreByStageId(candidate, stageId) as testScore; else noScore"
                      class="test-score-container">
                      <span class="test-score-text">
                        <p>
                          {{ testScore.marks }}
                          <span class="total-marks">/{{testScore.total_marks}}</span>
                        </p>
                      </span>
                      <p-divider [style]="{margin: '4px'}" layout="vertical"></p-divider>
                      <button pButton title="View Score" class="p-button-text simple-btn testScore"
                        icon="pi pi-chart-bar" (click)="$event.stopPropagation(); viewResultAnalysis(candidate, stageId)">
                      </button>
                    </span>
                  </ng-container>
                  <ng-template #noScore>
                    <span [style]="{width: '3vw'}">
                      <p [style]="{margin: '0 1.5vw'}">-</p>
                    </span>
                  </ng-template>
                </span>


                <span *ngSwitchCase="col.field === 'joiningDate'">
                  <span>{{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? (candidate[col.field] | date: dateFormat) : '-'}}</span>
                </span>


                <span *ngSwitchCase="col.field === 'isDocumentsSubmitted'">
                  <span class="submission-status">
                    {{ candidate[col.field] ? 'Submitted' : 'Not Submitted' }}
                    <ng-container *ngIf="candidate[col.field]">
                      <span class="separator">|</span>
                      <i class="pi pi-chart-bar status-icon" pTooltip="View Documentation Details" tooltipPosition="top"
                        tooltipStyleClass="custom-tooltip"
                        (click)="$event.stopPropagation(); onDocumentationIconClick(candidate)"
                        style="cursor: pointer; color: #007bff;"></i>
                    </ng-container>
                  </span>
                </span>


                <span *ngSwitchCase="col.field === 'feedbackStatus'">
                  <span class="submission-status" (click)="handleFeedbackClick($event, candidate)"
                    [pTooltip]="(!candidate.isFeedbackSubmitted && candidate['status']?.toLowerCase() === 'completed') ? 'Submit Feedback Details' : (candidate.isFeedbackSubmitted ? 'View Feedback Details' : '')"
                    tooltipPosition="top" tooltipStyleClass="custom-tooltip">
                    {{ candidate.isFeedbackSubmitted ? 'Submitted' : 'Not Submitted' }}
                    <ng-container *ngIf="!candidate.isFeedbackSubmitted && candidate['status']?.toLowerCase() === 'completed'">
                      <span class="separator">|</span>
                      <i class="pi pi-comments status-icon" style="cursor: pointer; color: #ef4444;"></i>
                    </ng-container>
                    <ng-container *ngIf="candidate.isFeedbackSubmitted">
                      <span class="separator">|</span>
                      <i class="pi pi-comments status-icon" style="cursor: pointer; color: #28a745;"></i>
                    </ng-container>
                  </span>
                </span>



                <span *ngSwitchCase="col.field === 'dob'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? (candidate[col.field] | date: dateFormat) : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'registeredAt'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? formatDateTime(candidate[col.field]) : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'testStartTime'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? candidate[col.field] : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'testSubmitTime'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? candidate[col.field] : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'documentationCreatedAt'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? formatDateTime(candidate[col.field]) : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'documentSubmittedAt'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? formatDateTime(candidate[col.field]) : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'interviewStartAt'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? formatDateTime(candidate[col.field]) : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'offerSentAt'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? formatDateTime(candidate[col.field]) : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'offerSubmittedAt'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? formatDateTime(candidate[col.field]) : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'contestStartTime'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? candidate[col.field] : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'contestEndTime'">
                  {{candidate[col.field] && candidate[col.field] !== '-' && candidate[col.field] !== '' ? candidate[col.field] : '-'}}
                </span>

                <span *ngSwitchCase="col.field === 'gender'">
                  {{candidate[col.field] && candidate[col.field] !== '-' ? (candidate[col.field] | titleCaseUnderscore) : '-'}}
                </span>

                <span [ngClass]="{'capitalize': capitalize(col)}" *ngSwitchDefault>
                  {{ candidate[col.field] && candidate[col.field] !== null && candidate[col.field] !== '' &&
                  candidate[col.field] !== '-' ? candidate[col.field] : '-' }}
                </span>
              </span>
            </ng-container>
            <ng-template #skeletonCell>
              <div class="skeleton" [ngClass]="{
                  'skeleton-badge': col.field === 'status',
                  'skeleton-text': col.field !== 'status' && col.field !== 'testScore' && col.field !== 'stageId',
                  'skeleton-text-short': col.field === 'testScore' || col.field === 'stageId',
                  'skeleton-text-long': col.field === 'offerLocations'
                }"></div>
            </ng-template>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="_selectedColumns.length + 2" class="empty-message-container">
            <div class="empty-state">
              <div class="empty-state-icon">
                <i class="pi pi-search"></i>
              </div>
              <h3 class="empty-state-title">No Candidates Found</h3>
              <p class="empty-state-description">
                Try adjusting filters or search terms.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-popover #stagesOP styleClass="no-padding-overlay move-stage-overlay-panel">
    <ng-template #content>
      <div class="stage-overlay">
        <div *ngFor="let stg of stageList" class="stage-option" (click)="moveStageSlider(stg, stagesOP)"
          (keydown)="moveStageSlider(stg, stagesOP)">
          <span class="stage-name">{{stg.name}}</span>
          <span class="stage-type-tag" [ngClass]="getStageTypeClass(stg.type)">
            {{stg.type | uppercase}}
          </span>
          <span class="stage-indicator"></span>
        </div>
      </div>
    </ng-template>
  </p-popover>

  <p-popover #statusOP styleClass="no-padding-overlay change-status-overlay-panel">
    <ng-template #content>
      <div class="status-overlay">
        <div *ngFor="let status of changeStatusOptions" class="status-option"
          (click)="changeStatusSlider(status); statusOP.hide()">
          <span class="status-name" [ngClass]="getStatusTextClass(status.name)">{{status.name}}</span>
          <span class="status-indicator"></span>
        </div>
      </div>
    </ng-template>
  </p-popover>
</div>


<div *ngIf="displayUserDetails">
  <p-drawer class="candidateDetaile" [transitionOptions]="'0ms'" [(visible)]="displayUserDetails"
    styleClass="p-drawer-lg" position="right" [style]="{width: '650px'}">
    <app-candidate-info [selectedUser]="selectedUser" [numberOfStages]="stages.length" [disableActivity]="false"
      [disableStage]="false" [disableFeedback]="false"></app-candidate-info>
  </p-drawer>
</div>


<app-send-email 
  *ngIf="sendEmailSlider" 
  [selectedUsersList]="selectedUsersList" 
  [stage]="stage" 
  [assignCohortData]="sendOfferMail"
  [sendMailHeader]="sendMailHeader" 
  [sendDocumentation]="sendDocumentation"
  (mailSent)="mailSent($event)">
</app-send-email>


<p-dialog [(visible)]="feedbackSlider" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '1050px', maxHeight: '90vh' }" [baseZIndex]="10000" styleClass="feedback-dialog"
  (onHide)="onFeedbackDialogHide()">
  
  <ng-template pTemplate="header">
    <div class="feedback-dialog-header">
      <h2 class="dialog-title">Feedback</h2>
      <button *ngIf="feedbackMode === 'view' || feedbackMode === 'edit'" pButton type="button"
        class="download-feedback-header-btn" label="Download Feedback"
        (click)="$event.stopPropagation(); feedbackFormComponent.downloadFeedback()">
      </button>
    </div>
  </ng-template>

  <div class="feedback-dialog-body"
    [class.has-panel]="panelMembers.length > 1 || (panelMembers.length > 0 && feedbackMode === 'create')">
    <div class="panel-members-sidebar"
      *ngIf="panelMembers.length > 1 || (panelMembers.length > 0 && feedbackMode === 'create')">
      <div class="panel-members-title">PANEL MEMBERS ({{panelMembers.length}})</div>
      <ng-container *ngIf="groupedPanelMembers.length <= 1">
        <div class="panel-member-item" *ngFor="let member of panelMembers"
          [class.active]="(member.isVirtual && selectedPanelMemberFormId === null && selectedPanelMemberId === member.submitted_by_id) || (!member.isVirtual && selectedPanelMemberFormId === member.form_id)"
          (click)="selectPanelMember(member)">
          <div class="panel-member-avatar" [style.background-color]="getAvatarColor(member.submitted_by_name)">
            {{ getInitials(member.submitted_by_name) }}
          </div>
          <div class="panel-member-info">
            <span class="panel-member-name">
              {{ member.submitted_by_name }}
              <span *ngIf="member.submitted_by_id === currentUserId" class="you-tag">(You)</span>
            </span>
            <span class="panel-member-date" *ngIf="member.isVirtual" style="color: #ef4444;">
              Not Submitted
            </span>
            <span class="panel-member-date" *ngIf="!member.isVirtual">
              <i class="pi pi-check-circle" style="color: #22c55e; font-size: 11px;"></i>
              {{ member.submitted_date | date: 'dd-MM-yyyy hh:mm a' }}
            </span>
          </div>
          <i class="pi pi-chevron-right panel-member-arrow"></i>
        </div>
      </ng-container>

      <ng-container *ngIf="groupedPanelMembers.length > 1">
        <div *ngFor="let group of groupedPanelMembers" class="interview-group">
          <div class="interview-group-label">{{ group.label }}</div>
          <div class="panel-member-item" *ngFor="let member of group.members"
            [class.active]="(member.isVirtual && selectedPanelMemberFormId === null && selectedPanelMemberId === member.submitted_by_id) || (!member.isVirtual && selectedPanelMemberFormId === member.form_id)"
            (click)="selectPanelMember(member)">
            <div class="panel-member-avatar" [style.background-color]="getAvatarColor(member.submitted_by_name)">
              {{ getInitials(member.submitted_by_name) }}
            </div>
            <div class="panel-member-info">
              <span class="panel-member-name">
                {{ member.submitted_by_name }}
                <span *ngIf="member.submitted_by_id === currentUserId" class="you-tag">(You)</span>
              </span>
              <span class="panel-member-date" *ngIf="member.isVirtual" style="color: #ef4444;">
                Not Submitted
              </span>
              <span class="panel-member-date" *ngIf="!member.isVirtual">
                <i class="pi pi-check-circle" style="color: #22c55e; font-size: 11px;"></i>
                {{ member.submitted_date | date: 'dd-MM-yyyy hh:mm a' }}
              </span>
            </div>
            <i class="pi pi-chevron-right panel-member-arrow"></i>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="feedback-form-content">
      <app-feedback-form #feedbackFormComponent [headerData]="feedbackHeaderData"
        [candidateDetails]="selectedCandidateForFeedback" [feedbackMode]="feedbackMode" [formUuid]="feedbackFormUuid"
        (closeFeedbackSlider)="onCloseFeedbackSlider($event)" (panelMembersLoaded)="onPanelMembersLoaded($event)">
      </app-feedback-form>
    </div>
  </div>
</p-dialog>


<p-dialog [draggable]="false" header="Documentation Details" [(visible)]="showDocumentationDialog" [modal]="true"
  appendTo="body" [style]="{width: '75vw', height: '80vh'}" (onHide)="closeDocumentationDialog()">

  <div *ngIf="isLoadingDetails" class="loading-feedback">
    <p-progressSpinner strokeWidth="2" animationDuration="0.5s"></p-progressSpinner>
  </div>

  <div class="documentation-details-container">
    <div *ngFor="let section of documentationSections; let last = last; trackBy: trackBySectionName">
      <div class="documentation-section">
        <div class="documentation-section-title">{{ section.name }}</div>
        <hr class="dialog-section-underline">
      </div>
      <div *ngFor="let item of section.fields; trackBy: trackByIndex">
        <div class="documentation-row">
          <div class="documentation-field label">{{ item.label }}</div>
          <div class="documentation-field separator">:</div>
          <div class="documentation-field value" [innerHTML]="item.value ? item.value : '-'"></div>
        </div>
      </div>
      <div *ngIf="!last" class="horizontal-line-wrapper">
        <hr class="section-divider" />
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog [draggable]="false" header="Feedback Details" [(visible)]="showFeedbackDialog" [modal]="true" appendTo="body"
  [style]="{width: '75vw', height: '80vh'}" (onHide)="closeFeedbackDialog()">

  <div *ngIf="isLoadingDetails" class="loading-feedback">
    <p-progressSpinner strokeWidth="2" animationDuration="0.5s"></p-progressSpinner>
  </div>

  <div *ngIf="!isLoadingDetails">
    <div class="feedback-details-container">
      <div *ngFor="let section of feedbackSections; let last = last; trackBy: trackBySectionName">
        <div class="feedback-section">
          <div class="feedback-section-title">{{ section.name }}</div>
          <hr class="dialog-section-underline">
        </div>
        <div *ngFor="let item of section.fields; trackBy: trackByIndex">
          <div class="feedback-row">
            <div class="feedback-field label">{{ item.label }}</div>
            <div class="feedback-field separator">:</div>
            <div class="feedback-field value" [innerHTML]="item.value ? item.value : '-'"></div>
          </div>
        </div>
        <div *ngIf="!last" class="horizontal-line-wrapper">
          <hr class="section-divider" />
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<div class="modal-backdrop" *ngIf="showSyncScoresConfirmDialog" (click)="closeSyncScoresConfirmDialog()">
  <div class="modal-container sync-scores-confirm-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Sync Test Scores</h3>
    </div>
    <div class="modal-body">
      <p class="confirmation-text">
        Are you sure you want to sync the scores for all candidates who are in <strong>'Slot Sent'</strong> status?
      </p>
    </div>
    <div class="modal-footer">
      <button type="button"
        class="btn btn-secondary"
        (click)="closeSyncScoresConfirmDialog()"
        [disabled]="syncScoresLoading">
        Cancel
      </button>
      <button type="button"
        class="btn btn-primary"
        (click)="syncTestScores()"
        [disabled]="syncScoresLoading">
        <span *ngIf="syncScoresLoading" class="spinner"></span>
        <span *ngIf="!syncScoresLoading">Confirm</span>
        <span *ngIf="syncScoresLoading">Syncing...</span>
      </button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showSyncContestConfirmDialog" (click)="closeSyncContestConfirmDialog()">
  <div class="modal-container sync-scores-confirm-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Sync Test Details</h3>
    </div>
    <div class="modal-body">
      <p class="confirmation-text">
        Are you sure you want to sync the test details for this stage?
      </p>
    </div>
    <div class="modal-footer">
      <button type="button"
        class="btn btn-secondary"
        (click)="closeSyncContestConfirmDialog()"
        [disabled]="syncContestLoading">
        Cancel
      </button>
      <button type="button"
        class="btn btn-primary"
        (click)="syncContest()"
        [disabled]="syncContestLoading">
        <span *ngIf="syncContestLoading" class="spinner"></span>
        <span *ngIf="!syncContestLoading">Confirm</span>
        <span *ngIf="syncContestLoading">Syncing...</span>
      </button>
    </div>
  </div>
</div>

<p-toast></p-toast>